import Vue from 'vue'
import App from './App.vue'
import router from './router'
import mgmt from '@/views/pages/Mgmt'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import axios from 'axios'
import Vuetify from 'vuetify/lib'
import VueI18n from 'vue-i18n'
import VueAxios from 'vue-axios'
import auth from './plugins/auth.js'
import Croppa from 'vue-croppa'
import VueSweetalert2 from 'vue-sweetalert2'
import '@/sass/overrides.sass'
import 'leaflet/dist/leaflet.css'
import Swal from 'sweetalert2'
import VueMoment from 'vue-moment'
import moment from 'moment'
import colors from 'vuetify/lib/util/colors'
import VueInteractJs from "vue-interactjs";
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import FlipCountdown from 'vue2-flip-countdown'
import en from 'vuetify/es5/locale/en'


const all_vuetify_trad = require.context('vuetify/es5/locale/', true, /\.(js)$/i);
let vuetify_trad = {}
all_vuetify_trad.keys().map(key => {
  const name = key.match(/\w+/)[0];
  vuetify_trad[name] = all_vuetify_trad(key)
});

if (typeof (API_URL) !== 'undefined') appInit(API_URL);
else if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') initializeServerWithConfig(window.location.port);
else appInit(window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":" + window.location.port : ""));

function initializeServerWithConfig(port) {
  console.log("Starting MyASD API with port=" + port);
  let xhr = new XMLHttpRequest();
  xhr.open('GET', '/config.json', true);
  xhr.responseType = 'json';
  xhr.onload = function (e) {
    if (this.status == 200) {
      let arrConf = this.response;
      let config = arrConf.filter(config => { return config.port === port });
      if (config.length === 1) appInit(config[0].apiUrl)
    }
  }
  xhr.send();
}

function isRemoteFrontend() {
  var req = new XMLHttpRequest();
  req.open('GET', "/favicon.ico", false);
  req.send(null);
  let remote = req.getResponseHeader("frontend-remote");
  return remote ? remote : ""
}

// Inizializza applicazione
function appInit(hostname) {
  console.log('starting with endpoint: ' + hostname)
  Vue.config.productionTip = false
  axios.defaults.crossDomain = true
  axios.defaults.baseURL = hostname + '/API';
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
  axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'


  Vue.use(VueI18n)
  Vue.use(Vuetify)
  Vue.use(VueAxios, axios)
  Vue.use(VueSweetalert2)
  Vue.use(Croppa)
  Vue.use(VueMoment);
  Vue.use(FlipCountdown);
  Vue.use(VueInteractJs);


  // Inizio ad impostare la lingua scelta con quella del browser e come scelte disponibili italiano e inglese
  window.selectedLanguage = (navigator.language || navigator.userLanguage).split('-')[0];
  window.supportedLanguage = [
    {
      "code": "it",
      "dex": "Italiano"
    },
    {
      "code": "en",
      "dex": "English"
    }
  ];

  class CustomFormatter {
    constructor(options) {

    }
    interpolate(message, values) {
      // Capitalize first lettere
      let string = message.charAt(0).toUpperCase() + message.slice(1)
      if (Array.isArray(values)) {
        string = string.replace(/\{\s*(\d+)\s*\}/g, (placeholder, index) => {
          return values[index] === undefined ? placeholder : String(values[index]);
        });
      } else if (values && typeof values === "object") {
        string = string.replace(/\{\s*([^{}\s]+)\s*\}/g, (placeholder, key) => {
          return Object.prototype.hasOwnProperty.call(values, key)
            ? String(values[key])
            : placeholder;
        });
      }
      return [string]
    }
  }

  // Se c'è lingua salvata in local storage, la leggo da li
  let lastLanguage = localStorage.getItem('selectedLanguage');
  if (lastLanguage) window.selectedLanguage = lastLanguage
  localStorage.setItem('selectedLanguage', window.selectedLanguage);


  let i18n = new VueI18n({
    locale: window.selectedLanguage,
    formatter: new CustomFormatter(),
    fallbackLocale: "en",
    ...vuetify_trad["en"].default
  })

  // Handler globali
  const networkErrorRsp = Vue.observable({ visible: false, error: '', discreteError: false })
  Vue.prototype.$networkError = {
    networkErrorRsp,
  }
  const documentViewerRsp = Vue.observable({ docUrl: false })
  Vue.prototype.$documentViewer = {
    documentViewerRsp,
  }
  const changeAvatarRsp = Vue.observable({ updated: false })
  Vue.prototype.$changeAvatar = {
    changeAvatarRsp,
  }
  const updateCreditiRsp = Vue.observable({ updated: false })
  Vue.prototype.$updateCrediti = {
    updateCreditiRsp,
  }

  const pwaRsp = Vue.observable({ prompt: null })
  Vue.prototype.$pwa = {
    pwaRsp,
  }

  Object.defineProperty(Vue.prototype, '$errors', {
    get() {
      return errors.errors
    },

    set(value) {
      errors.errors = value
    }
  })

  const scroll = Vue.observable({ toTop: false })
  const refresh = Vue.observable({ flag: false })
  const loader = Vue.observable({ arrRqs: [] })
  const dialogLoader = Vue.observable({ visible: false })

  Vue.prototype.$globalHandler = {
    scroll,
    refresh,
    loader,
    dialogLoader
  }

  Vue.axios.defaults.timeout = 120000

  Vue.axios.interceptors.request.use(function (request) {
    loader.arrRqs.push(request.url);
    return request;
  }, function (error) {
    console.dir(error);
  })

  Vue.axios.interceptors.response.use(function (response) {

    networkErrorRsp.visible = false
    loader.arrRqs = loader.arrRqs.filter(rqs => { return rqs !== response.config.url });
    networkErrorRsp.error = ''
    networkErrorRsp.discreteError = false
    return response
  }, function (error) {
    loader.arrRqs = loader.arrRqs.filter(rqs => { return error.config && rqs !== error.config.url });
    if (error.response && error.response.status === 401 && error.config && error.config.url && error.config.url.startsWith('/mgmt/')) {
      localStorage.removeItem('mgmtAuthToken');
      if (!window.location.hash.startsWith('#/mgmt/login')) window.location = '/#/mgmt/login';
      return Promise.reject(error);
    }
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config && error.config.url ? error.config.url : '';
      const isPublicAuthRequest = requestUrl.startsWith('/public/portal/login') || requestUrl.startsWith('/public/portal/requestResetPassword');

      // For login/reset requests, let the page-level catch show backend message.
      if (isPublicAuthRequest) {
        return Promise.reject(error);
      }

      if (!window.location.hash.startsWith('#/auth/login')) {
        window.location = '/#/auth/login';
      }
      return Promise.reject(error);
    }
    else if (error.response && error.response.status === 406) {
      networkErrorRsp.discreteError = true
      networkErrorRsp.permanentMessage = error.response.data
      networkErrorRsp.visible = true
    }
    else if (!location.hash.startsWith('#/error/')) {
      networkErrorRsp.visible = true
      networkErrorRsp.error = error
      networkErrorRsp.discreteError = error.config && error.config.headers && error.config.headers.discreteError ? error.config.headers.discreteError : false
      return Promise.reject(error)
    }
  })

  // Vue.directive('click-outside', {
  //   bind() {
  //     this.event = event => this.vm.$emit(this.expression, event)
  //     this.el.addEventListener('click', this.stopProp)
  //     document.body.addEventListener('click', this.event)
  //   },
  //   unbind() {
  //     this.el.removeEventListener('click', this.stopProp)
  //     document.body.removeEventListener('click', this.event)
  //   },

  //   stopProp(event) { event.stopPropagation() }
  // })

  // Mixins chiamate ajax
  Vue.mixin({
    methods: {

      isValidDate(d) {
        return d instanceof Date && !isNaN(d);
      },
      parseDate: function (string, min, max) {
        let _ = this;
        let date = new Date(string);
        if (_.isValidDate(date) && (!min || date >= min) && (!max || date <= max)) return _.$moment(date).format("YYYY-MM-DD");
        let momentRis = _.$moment(string, ["DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD"])
        let momentDate = new Date(momentRis.format("YYYY-MM-DD"));
        if (_.isValidDate(momentDate) && momentRis._pf.unusedTokens.length === 0 && (!min || momentDate >= min) && (!max || momentDate <= max)) return momentDate;

        return false;
      },
      getPasscode: function () {
        return window.location.hostname + '_' + window.location.port
      },
      encryptCodes: function (content, passcode = '') {
        if (passcode === '') passcode = this.getPasscode();
        var result = []; var passLen = passcode.length;
        for (var i = 0; i < content.length; i++) {
          var passOffset = i % passLen;
          var calAscii = (content.charCodeAt(i) + passcode.charCodeAt(passOffset));
          result.push(calAscii);
        }
        return window.btoa(JSON.stringify(result));
      },
      decryptCodes: function (content, passcode = '') {
        if (passcode === '') passcode = this.getPasscode();
        var result = []; var str = '';
        var codesArr = JSON.parse(window.atob(content));
        var passLen = passcode.length;
        for (var i = 0; i < codesArr.length; i++) {
          var passOffset = i % passLen;
          var calAscii = (codesArr[i] - passcode.charCodeAt(passOffset));
          result.push(calAscii);
        }
        for (var i = 0; i < result.length; i++) {
          var ch = String.fromCharCode(result[i]); str += ch;
        }
        return str;
      },
      checkEnabledModule: function (module) {
        let modules = window.systemData.modules
        if (modules.includes(module)) return true
        else return false
      },
      checkUserRole: function (mod, role) {
        let token = localStorage.getItem('rToken')
        if (!token) return false;
        let RBAC = JSON.parse(this.decryptCodes(token))
        if (!RBAC[mod]) return false
        if (!RBAC[mod][role]) return false;
        return RBAC[mod][role]
      },
      externalizeLink: function (link) {
        if (link.startsWith(axios.defaults.baseURL)) return link;
        else return axios.defaults.baseURL + link;
      },
      authorizeLink: function (link) {
        link = this.externalizeLink(link);
        if (link.includes('?')) link += '&';
        else link += '?';
        return link + 'authToken=' + btoa(localStorage.getItem('authToken')) + "&timezoneOffset=" + new Date().getTimezoneOffset() + "&locale=" + window.selectedLanguage
      },
      getQueryString: function (params) {
        return Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
      },
      capitalize: function (s) {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
      },
      getToken(mode = 'portal') {
        if (mode === 'mgmt') return localStorage.getItem('mgmtAuthToken')
        return localStorage.getItem('authToken')
      },
      isLoggedIn(mode = 'portal') {
        let token = this.getToken(mode);
        if (token) return true;
        else return false;
      },
      setAuthToken(token, window_location_href) {
        let _ = this;
        // Recupero ruoli utente
        localStorage.setItem("authToken", token);
        _.chiamataAxios(
          "GET",
          "/auth/portal/getUserRBAC").then(response => {
            let RBAC = {};
            if (response && response.data && response.data.RBAC) response.data.RBAC.forEach((element) => {
              if (!RBAC[element.module]) RBAC[element.module] = {};
              if (!RBAC[element.module][element.code])
                RBAC[element.module][element.code] = true;
            });
            let cryptToken = _.encryptCodes(JSON.stringify(RBAC));
            localStorage.setItem("rToken", cryptToken);
          }
          );

        // Se c'è from uri nel link, faccio redirect a dove mi trovavo prima
        let uri = [];
        let toUri = null;
        if (window_location_href) uri = window_location_href.split("/");
        if (
          uri.length >= 3 &&
          uri[uri.length - 3] === "auth" &&
          uri[uri.length - 2] === "login" &&
          !uri[uri.length - 1].startsWith('?ssoResponse=')
        ) {
          let toUri = atob(uri[uri.length - 1]);
          // Se arrivo da login, la escludo
          let toUriArr = toUri.split("/");
          if (
            toUriArr.length >= 3 &&
            toUriArr[toUriArr.length - 3] === "auth" &&
            toUriArr[toUriArr.length - 2] === "login"
          ) toUri = null;
        }
        if (toUri) window.location.href = toUri;
        else _.$router.push("/portal");
      },
      antiCache(url) {
        let _ = this
        let timestamp = new Date().getTime();
        if (url && url.indexOf('?') != -1) url += '&t=' + timestamp
        else url += '?t=' + timestamp
        return url;
      },
      getQueryParameterByName(name, url = window.location.href) {
        const [hash, query] = url.split('#')[1].split('?')
        const params = Object.fromEntries(new URLSearchParams(query))
        if (params && params[name]) return params[name]
      },
      chiamataAxios: async function (method, url, params = {}) {

        if (!params.msg) params.msg = "error"
        if (!params.unauthLoginRedirect) params.unauthLoginRedirect = true
        if (!params.secTimeout) params.secTimeout = 30
        if (params.dialogLoader) dialogLoader.visible = true;

        // anti-cache
        let _ = this
        let timestamp = new Date().getTime();
        if (url && url.indexOf('?') != -1) url += '&t=' + timestamp
        else url += '?t=' + timestamp

        try {
          let headers = {
            'local': window.selectedLanguage,
            'timezoneOffset': new Date().getTimezoneOffset(),
            'discreteError': params.discreteError,
            "Cache-Control": "no-cache"
          }
          let isMgmtCall = url && url.startsWith('/mgmt/')
          let authToken = isMgmtCall ? localStorage.getItem('mgmtAuthToken') : localStorage.getItem('authToken')
          if (authToken) headers['Authorization'] = "Bearer " + authToken
          let axiosParams = {
            method: method,
            url: url,
            timeout: params.secTimeout * 1000,
            headers: headers
          }
          if (params.body) axiosParams.data = params.body
          let json = await this.axios(axiosParams)
          if (params.unauthLoginRedirect !== false && json.data.msg.unauthorized) {
            _.$router.push("/auth/login/" + btoa(window.location.href));
            if (params.dialogLoader) dialogLoader.visible = false;
            return false;
          }
          if (!json.data.data) json.data.data = {};
          const escapeHtml = (value) => String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
          const disseminationResult = json.data.msg && json.data.msg.disseminations;
          const hasDisseminations = disseminationResult && typeof disseminationResult === 'object' && Object.keys(disseminationResult).length > 0;
          let text = json.data.msg.msgTxt;

          if (hasDisseminations) {
            const disseminationLines = Object.keys(disseminationResult).map((key) => {
              const item = disseminationResult[key] || {};
              const success = item.esito === true || item.esito === 'true' || item.esito === 1 || item.esito === '1';
              const icon = success
                ? '<span style="color:#2e7d32;font-weight:700;">&#10004;</span>'
                : '<span style="color:#c62828;font-weight:700;">&#10008;</span>';
              const message = item.message || '';
              const borderColor = success ? '#2e7d32' : '#c62828';
              return `<div style="border:1px solid ${borderColor};border-radius:8px;padding:10px 12px;margin:8px 0;text-align:left;">`
                + `<div style="display:flex;align-items:center;gap:8px;line-height:1.3;">${icon} <strong>${escapeHtml(key)}</strong></div>`
                + `<div style="margin-top:6px;padding-left:24px;line-height:1.35;">${escapeHtml(message)}</div>`
                + `</div>`;
            });

            if (disseminationLines.length > 0) {
              const mainMessage = escapeHtml(json.data.msg.msgTxt || _.$t('operation_successfully_completed'));
              text = `${mainMessage}<br><br>${disseminationLines.join('')}`;
              json.data.msg.msgTxt = text;
            }
          }

          if (!params.silentError && ((params.msg === 'error' && json.data.msg.severity > 0) || params.msg === 'always')) {

            let title = _.$t('operation_successfully_completed')
            let type = "success"
            if (json.data.msg.msgId !== "4008" && json.data.msg.severity > 0) {
              title = _.$t('there_was_an_error')
              type = "error";
              if (!params.returnDataOnError) json.data.data = false;
            }
            Swal.fire({
              title: title,
              // type: type,
              html: text,
              // didOpen: () => {
              //   const htmlContainer = document.querySelector('.swal2-html-container');
              //   if (htmlContainer) {
              //     htmlContainer.style.userSelect = 'text';
              //     htmlContainer.style.webkitUserSelect = 'text';
              //     htmlContainer.style.cursor = 'text';
              //   }
              // },
            })
          }
          if (params.dialogLoader) dialogLoader.visible = false;
          return json.data;
        }
        catch (error) {
          if (params.dialogLoader) dialogLoader.visible = false;
          console.dir(error)
          if (error.response && error.response.data && error.response.data.msg && error.response.data.msg.severity > 0) {
            let json = { data: error.response.data };
            if (!params.returnDataOnError) json = { data: false };
            console.dir(json)
            if (!params.silentError) {
              let popup = {
                // title: 'there_was_an_error',
                type: "error",
                html: error.response.data.msg.msgTxt,
                didOpen: () => {
                  const htmlContainer = document.querySelector('.swal2-html-container');
                  if (htmlContainer) {
                    htmlContainer.style.userSelect = 'text';
                    htmlContainer.style.webkitUserSelect = 'text';
                    htmlContainer.style.cursor = 'text';
                  }
                },
              };
              Swal.fire(popup)
            }
            return json;
          }
          if (error.response && error.response.status !== 406) {
            console.log("AXIOS error: [" + url + "] " + error)
            networkErrorRsp.discreteError = params.discreteError
            networkErrorRsp.error = "[" + url + "] " + error
            networkErrorRsp.visible = true
            return null;
          }
        }
      },
    },
  })


  const viewport_meta = document.getElementById('viewport-meta')
  const contentDesktop = 'width=device-width, height=device-height, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0'
  const contentMobile = 'width=device-width, height=device-height, initial-scale=0.9, user-scalable=no, minimum-scale=0.9, maximum-scale=0.9'
  if (screen.width <= 648 && !window.hasOwnProperty("_cordovaNative")) viewport_meta.setAttribute('content', contentMobile)
  else viewport_meta.setAttribute('content', contentDesktop)

  // Get system data before start
  let timestamp = new Date().getTime();
  let mode = "portal";
  if (window.location.hash.startsWith("#/mgmt/") || portal_mode && portal_mode.active && portal_mode.mode === "mgmt") {
    mode = "mgmt"
  }
  let mgmtToken = localStorage.getItem('mgmtAuthToken');

  auth(router)

  function mountBareApp() {
    const vuetify = new Vuetify({
      lang: {
        locales: { en },
        current: "en"
      },
    })
    Vue.use(TiptapVuetifyPlugin, {
      vuetify,
      iconsGroup: 'mdi'
    })
    new Vue({
      router,
      vuetify,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  }

  if (mode === "mgmt" && !mgmtToken) {
    mountBareApp();
    return;
  }
  if (portal_mode.error) {
    mountBareApp();
    return;
  }

  let requestHeaders = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }
  if (mode === "mgmt" && mgmtToken) {
    requestHeaders['Authorization'] = 'Bearer ' + mgmtToken;
  }

  Vue.axios({
    method: 'GET',
    url: mode === "portal" ? '/public/portal/getSystemData?t=' + timestamp : '/mgmt/getSystemData?t=' + timestamp,
    headers: requestHeaders,
  }).then(function (json) {
    if (json.data.msg.severity > 0) {
      // notifica errore
      if (!location.hash.startsWith('#/error/')) window.location = '/#/error/systemDown'
      networkErrorRsp.discreteError = false
      networkErrorRsp.visible = false
      networkErrorRsp.error = ''
    } else {

      let messages = {};
      let vuetify_locales = {}
      for (let language in json.data.data.traduzioni) {
        let vuetify_traduction = vuetify_trad[language] ? vuetify_trad[language] : vuetify_trad[json.defaultLanguage]
        let myasd_traduction = json.data.data.traduzioni[language] ? json.data.data.traduzioni[language] : json.data.data.traduzioni[json.defaultLanguage]
        messages[language] = { ...myasd_traduction, ...vuetify_traduction.default };
        vuetify_locales[language] = vuetify_traduction.default

      }

      i18n = new VueI18n({
        locale: window.selectedLanguage,
        formatter: new CustomFormatter(),
        fallbackLocale: json.defaultLanguage,
        messages,
      })

      // Recupero lingue supportate da server
      window.supportedLanguage = json.data.data.supportedLanguage
      // Se non scelta lingua o quella scelta non è supportata imposto default da server
      if (!window.selectedLanguage || !window.supportedLanguage.map(lingua => { return lingua.language }).includes(window.selectedLanguage)) window.selectedLanguage = json.data.defaultLanguage
      localStorage.setItem('selectedLanguage', window.selectedLanguage);
      window.systemData = json.data.data

      let link = document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = mode === "portal" ? Vue.axios.defaults.baseURL + '/public/portal/favicon' : '/favicon.ico'
      document.getElementsByTagName('head')[0].appendChild(link)
      document.title = window.systemData.ASD ? window.systemData.ASD.nome : window.systemData.SYSTEM.title

      // Manifest json solo per portal
      if (mode === "portal") {
        let manifest = document.createElement('link')
        manifest.rel = 'manifest'
        manifest.href = '/API/manifest.json'
        document.getElementsByTagName('head')[0].appendChild(manifest)
      }

      let devFrontend = isRemoteFrontend();
      if (devFrontend && devFrontend !== "")
        window.systemData.SYSTEM.webFooter.unshift(
          '<span class="error--text">' + devFrontend + "</span>"
        );

      // Imposta tema
      const theme = {
        primary: window.systemData.THEME.color_primary,
        secondary: window.systemData.THEME.color_secondary,
        accent: window.systemData.THEME.color_accent,
        info: window.systemData.THEME.color_info,
        error: window.systemData.THEME.color_error,
        warning: window.systemData.THEME.color_warning,
        success: window.systemData.THEME.color_success,
      }
      const vuetify = new Vuetify({
        lang: {
          locales: vuetify_locales,
          current: window.selectedLanguage
        },
        theme: {
          options: {
            customProperties: true,
          },
          themes: {
            dark: theme,
            light: theme,
          },
        },
      })
      Vue.use(TiptapVuetifyPlugin, {
        // the next line is important! You need to provide the Vuetify Object to this place.
        vuetify, // same as "vuetify: vuetify"
        // optional, default to 'md' (default vuetify icons before v2.0.0)
        iconsGroup: 'mdi'
      })

      /* eslint-disable no-new */
      new Vue({
        router,
        vuetify,
        i18n,
        render: h => h(App),
      }).$mount('#app')
    }
  }).catch((error) => {
    if (mode === "mgmt" && error.response && error.response.status === 401) {
      localStorage.removeItem('mgmtAuthToken');
      window.location = '/#/mgmt/login';
      return;
    }
    if (error.response.status === 406) window.location = '/#/error/custom?errorId=' + error.response.status + '&errorMsg=' + error.response.data
    if (!location.hash.startsWith('#/error/')) window.location = '/#/error/systemDown'
    networkErrorRsp.discreteError = false
    networkErrorRsp.visible = false
    networkErrorRsp.error = ''
    const vuetify = new Vuetify({
      lang: {
        locales: { en },
        current: "en"
      },
    })
    Vue.use(TiptapVuetifyPlugin, {
      // the next line is important! You need to provide the Vuetify Object to this place.
      vuetify, // same as "vuetify: vuetify"
      // optional, default to 'md' (default vuetify icons before v2.0.0)
      iconsGroup: 'mdi'
    })
    new Vue({
      router,
      vuetify,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  })

}